import {EntityState, EntityStore, StoreConfig} from '@datorama/akita';
import {Injectable} from '@angular/core';
import {NotificationModel} from '../../models/notification.model';

export interface NotificationsState extends EntityState<NotificationModel> {
  planningSelectedDate: Date;
  savedParents: {[key: string]: string};
  selectedReportTab: number;
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'notifications' })
export class NotificationsStore extends EntityStore<NotificationsState, NotificationModel> {

  constructor() {
    super({ loading: false, savedParents: {} });
  }
}
